<template>
  <div class="document-box">
    <div
      v-if="empty == true"
      class="empty cursor"
      @click="adddocument('/material/new')"
    >
      <div class="adddocument"></div>
      <div class="newdocument">新建文档</div>
    </div>

    <div v-if="empty == false" class="content_box">
      <h3
        class=" title cursor"
        :title="item.title"
        @click="editArticles('doc')"
      >
        {{ item.title }}
      </h3>

      <p
        class="left intro cursor"
        @click="editArticles('doc')"
        v-html="item.intro"
      >
        {{ item.intro }}
      </p>

      <div class="document-bottom clear">
        <!-- <el-row :gutter="20">
          <el-col :span="18" class="document-bottom-left"> -->
        <div class="document-bottom-left fl">
          <span>{{ item.updateTime | dateformat("MM-DD HH:mm") }}</span>
          <span class="ml5">更新</span>
        </div>
        <div class="document-bottom-right fr" @click="deleteDoc">
          <el-tooltip effect="dark" content="删除" placement="top">
            <div class="doc-delete"></div>
          </el-tooltip>
        </div>
      </div>
      <div class="document-checkbox">
        <el-checkbox v-model="item.ischecked"></el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { saveDoc } from "../../assets/script/model";
import { mapActions } from "vuex";

export default {
  props: ["item", "empty"],
  data() {
    return {};
  },
  computed: {
    insertDoc: {
      get() {
        return this.$store.state.editorControl.insertDoc;
      },
      set(val) {
        this.$store.state.editorControl.insertDoc = val;
      }
    },
    allContent: {
      get() {
        return this.$store.state.editorControl.allContent;
      },
      set(val) {
        this.$store.state.editorControl.allContent = val;
      }
    },
    getTitle: {
      get() {
        return this.$store.state.wycContent.getTitle;
      },
      set(val) {
        this.$store.state.wycContent.getTitle = val;
      }
    }
  },
  methods: {
    ...mapActions("api", ["ADocDetail"]),
    async deleteDoc() {
      this.$emit("deleteDoc", this.item.docId);
    },
    adddocument(url) {
      this.insertDoc = new saveDoc();
      this.setLastEditContent(this.insertDoc);
      this.getTitle = "";
      this.setSessionDocId("");
      this.$router.push(url);
    },
    async editArticles(url) {
      let result = await this.ADocDetail({ docId: this.item.docId });
      if (result.errorCode === 0) {
        this.detailList = result.data;
        this.insertDoc.docId = this.item.docId;
        this.insertDoc.title = this.detailList.title;
        this.insertDoc.content = this.detailList.content;
        this.insertDoc.intro = this.detailList.intro;
        this.allContent = this.insertDoc.content;
        this.getTitle = this.insertDoc.title;
        this.setSessionDocId(this.item.docId);
        this.setLastEditContent(this.insertDoc);
        this.$router.push({ name: url });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
.document-box {
  width: 230px;
  height: 180px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(219, 227, 247, 1);
  border-radius: 4px;
  position: relative;
  padding: 16px;
  min-width: 230px;
  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 4px 2px #e5eaf7;
  }
  .title {
    .left();
    .rownumber(2);
    color: rgba(51, 51, 51, 1);
    font-size: 18px;
    line-height: 28px;
    height: 56px;
  }
  .intro {
    .rownumber(3);
    margin-top: 10px;
    width: auto;
    height: 56px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }
  .document-checkbox {
    position: absolute;
    top: 4px;
    right: 4px;
  }
  .document-bottom {
    margin-top: 8px;

    .document-bottom-left {
      .left();
      font-size: @font-size12;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
    .document-bottom-right {
      .cursor();
      height: 21px;
      display: flex;
      align-items: center;
      .doc-delete {
        width: 15px;
        height: 15px;
        background-image: url(../../assets/image/document/delete.png);
        // line-height: 20px;
        background-color: none !important;
      }
    }
  }
  .empty {
    width: auto;
    height: 148px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .adddocument {
      width: 36px;
      height: 36px;
      background-image: url(../../assets/image/document/big-add.png);
    }
    .newdocument {
      margin-top: 20px;
      width: 64px;
      height: 16px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      line-height: 18px;
    }
  }
}
//big-add.png
</style>
